import React, { useState, useEffect, useRef } from "react";
import "./popOver.scss";
import { useContent, useLanguages } from "../../../hooks/content";
import { Returntext } from "../../../pages/Landings/common/returnText";
import { ReactComponent as PopOverIcon } from "../../../icons/popOver.svg";
import { ReactComponent as DefaultIcon } from "../../../icons/def.svg";
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete-r.svg";

const PopOver = ({
  setActiveItem,
  setDeleteItem,
  item,
  setEditAddressPopUp,
  handleUpdate,
}) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();
  const [active, setActive] = useState(false);
  const popOverRef = useRef(null);

  const handleClickOutside = (event) => {
    if (popOverRef.current && !popOverRef.current.contains(event.target)) {
      setActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="pop-over" ref={popOverRef}>
      <PopOverIcon className="icon" onClick={() => setActive(!active)} />

      {active && (
        <div className="actions">
          {!item.isDefault && (
            <div
              className="p-btn"
              onClick={() => {
                handleUpdate(item.id);
                setActive(false);
              }}
            >
              <DefaultIcon />
              <span>
                {Returntext(contentManagementData, "MarkDefault", lang)}
              </span>
            </div>
          )}
          <div
            className="p-btn"
            onClick={() => {
              setActiveItem(item);
              setEditAddressPopUp(true);
              setActive(false);
            }}
          >
            <EditIcon />
            <span>
              {Returntext(contentManagementData, "EditDetails", lang)}
            </span>
          </div>
          {!item.isDefault && (
            <div
              className="p-btn red"
              onClick={() => {
                setActiveItem(item);
                setDeleteItem(true);
                setActive(false);
              }}
            >
              <DeleteIcon />
              <span>{Returntext(contentManagementData, "delete", lang)}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PopOver;
